import React, {useState, useEffect} from 'react';
import {Document, Page} from 'react-pdf';
import printJS from "print-js";
import {CircularProgress, Divider, Grid, Stack} from "@mui/joy";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import Input from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPrint} from "@fortawesome/free-solid-svg-icons";

const CodeBlank = ({blankProvider, code, setCode}) => {
    const [blankData, setBlankData] = useState(null);
    const [inputCode, setInputCode] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [viewWidth, setViewWidth] = useState(100);

    useEffect(() => {
        window.addEventListener('resize', updateWidth);
        if (code) {
            const accessToken = localStorage.getItem('accessToken');
            setLoading(true);
            blankProvider.getBlank(accessToken, code).then((response) => {
                setBlankData(response.data);
                setLoading(false);
                updateWidth();
            }).catch((error) => {
                console.log(error);
                setLoading(false);
            });
        }
        return () => {
            window.removeEventListener('resize', updateWidth);
        }
    }, [blankProvider, code]);

    const updateWidth = () => {
        setViewWidth(document.getElementById('blankView')?.offsetWidth);
    }

    const handlePrint = () => {
        printJS(blankData);
    }

    if (!code) {
        return <></>
    }

    if (isLoading) {
        return <CircularProgress />
    }

    return (
        <div>
            {blankData ? (
                <Stack>
                    <Sheet variant="soft" sx={{borderRadius: "lg", p: 3}}>
                        <Typography level="h4">Почтовый бланк</Typography>
                        <div id="blankView">
                            <Document file={blankData} >
                                <Page
                                    pageNumber={1}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                    width={viewWidth}
                                    className="blankPage"
                                />
                            </Document>
                        </div>
                    </Sheet>
                    <Button
                        onClick={handlePrint}
                        startDecorator={<FontAwesomeIcon icon={faPrint}/>}
                        sx={{mt: 3, p: 1.5, borderRadius: 'lg'}}
                    >
                        Печать
                    </Button>
                </Stack>

            ) : (
                <Sheet variant="soft" sx={{borderRadius: "lg", p: 3, gap: 2, display: "flex", flexDirection: "column"}}>
                    <Stack direction="row" gap={2}>
                        <img src="/empty.svg" alt="empty"></img>
                        <Typography >К сожалению, посылка с таким кодом не найдена, попробуйте ввести код вручную</Typography>
                    </Stack>
                    <Divider/>
                    <FormControl>
                        <FormLabel>Ввести код вручную</FormLabel>
                        <Grid container spacing={1}>
                            <Grid xs={10}>
                                <Input
                                    type="text"
                                    placeholder={"Введите код здесь"}
                                    onChange={(e) => setInputCode(e.target.value)} value={inputCode}
                                />
                            </Grid>
                            <Grid xs={2}>
                                <Button sx={{width: "100%"}} onClick={() => setCode(inputCode)}>Найти</Button>
                            </Grid>
                        </Grid>
                    </FormControl>
                </Sheet>
            )}
        </div>
    );
}

export default CodeBlank;
